/* tslint:disable */
/* eslint-disable */
/**
 * VoresAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateArticleCtaLeadForm,
    CreateArticleCtaLeadFormFromJSON,
    CreateArticleCtaLeadFormToJSON,
    CreateBusinessCtaLeadForm,
    CreateBusinessCtaLeadFormFromJSON,
    CreateBusinessCtaLeadFormToJSON,
    CreateLeadForm,
    CreateLeadFormFromJSON,
    CreateLeadFormToJSON,
    CreateLeadResultDto,
    CreateLeadResultDtoFromJSON,
    CreateLeadResultDtoToJSON,
    CreatePromotionLeadForm,
    CreatePromotionLeadFormFromJSON,
    CreatePromotionLeadFormToJSON,
} from '../models';

export interface CreateArticleCtaLeadRequest {
    createArticleCtaLeadForm?: CreateArticleCtaLeadForm;
}

export interface CreateBusinessCtaLeadRequest {
    createBusinessCtaLeadForm?: CreateBusinessCtaLeadForm;
}

export interface CreateLeadRequest {
    createLeadForm?: CreateLeadForm;
}

export interface CreatePromotionLeadRequest {
    createPromotionLeadForm?: CreatePromotionLeadForm;
}

/**
 * 
 */
export class LeadApi extends runtime.BaseAPI {

    /**
     */
    async createArticleCtaLeadRaw(requestParameters: CreateArticleCtaLeadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CreateLeadResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/leads/article-cta`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateArticleCtaLeadFormToJSON(requestParameters.createArticleCtaLeadForm),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async createArticleCtaLead(requestParameters: CreateArticleCtaLeadRequest, initOverrides?: RequestInit): Promise<CreateLeadResultDto> {
        const response = await this.createArticleCtaLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createBusinessCtaLeadRaw(requestParameters: CreateBusinessCtaLeadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CreateLeadResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/leads/business-cta`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBusinessCtaLeadFormToJSON(requestParameters.createBusinessCtaLeadForm),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async createBusinessCtaLead(requestParameters: CreateBusinessCtaLeadRequest, initOverrides?: RequestInit): Promise<CreateLeadResultDto> {
        const response = await this.createBusinessCtaLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLeadRaw(requestParameters: CreateLeadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CreateLeadResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/leads`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadFormToJSON(requestParameters.createLeadForm),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async createLead(requestParameters: CreateLeadRequest, initOverrides?: RequestInit): Promise<CreateLeadResultDto> {
        const response = await this.createLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createPromotionLeadRaw(requestParameters: CreatePromotionLeadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CreateLeadResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/leads/promotion`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePromotionLeadFormToJSON(requestParameters.createPromotionLeadForm),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async createPromotionLead(requestParameters: CreatePromotionLeadRequest, initOverrides?: RequestInit): Promise<CreateLeadResultDto> {
        const response = await this.createPromotionLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
